import { render } from "./Perks.vue?vue&type=template&id=73cbec0e&scoped=true"
import script from "./Perks.vue?vue&type=script&lang=js"
export * from "./Perks.vue?vue&type=script&lang=js"

import "./Perks.vue?vue&type=style&index=0&id=73cbec0e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cbec0e"]])

export default __exports__